import {
  WSElement,
  WSSectionToolbar,
  WSText,
  WSList
} from "@wingspanhq/fe-component-library";
import { IWorkLog } from "@wingspanhq/payments/dist/interfaces";
import { DataView } from "../../../shared/components/DataView";

type Props = {
  workLog?: IWorkLog;
  shimmer?: boolean;
};

export const WorkLogAdditionalDetailsPayerView: React.FC<Props> = props => {
  return (
    <WSElement>
      <WSSectionToolbar title="Additional details" />
      <DataView
        shimmer={props.shimmer}
        data={[
          {
            label: "Notes",
            value: "No notes",
            fullWidth: true
          },
          {
            label: "Attachments (optional)",
            value: (
              <WSList gap="S">
                <WSText>No attachments</WSText>
              </WSList>
            ),
            fullWidth: true
          }
        ]}
      />
    </WSElement>
  );
};
